import { LogLevel, Logger } from '@uploadcam/common';
import type * as Sentry from '@sentry/angular';

export class SentryLogger extends Logger {
  constructor(
    private readonly sentry: typeof Sentry,
    private readonly tag?: string,
  ) {
    super();
  }

  public logKeyValue(key: string, value: unknown): void {
    this.info(`${key}=${value}`);
  }

  protected createLoggerWithTag(tag: string): Logger {
    return new SentryLogger(this.sentry, tag);
  }

  protected handleLog(level: LogLevel, parameters: unknown[]): void {
    if ([LogLevel.Error, LogLevel.Fatal].includes(level)) {
      const error = parameters[0];

      this.sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
        data: { parameters: parameters.slice(1) },
      });
    } else {
      this.sentry.addBreadcrumb({
        type: 'debug',
        category: 'console',
        level: this.mapToSentryLevel(level),
        message: ((this.tag ? `[${this.tag}] ` : '') + parameters[0]) as string,
        data: { parameters },
      });
    }
  }

  private mapToSentryLevel(level: LogLevel): Sentry.SeverityLevel {
    const map: Record<LogLevel, Sentry.SeverityLevel> = {
      [LogLevel.Trace]: 'debug',
      [LogLevel.Debug]: 'debug',
      [LogLevel.Info]: 'info',
      [LogLevel.Warning]: 'warning',
      [LogLevel.Error]: 'error',
      [LogLevel.Fatal]: 'fatal',
    };

    return map[level];
  }
}
